export const zipByKey = (array, key) =>
    array?.reduce((result, item) => ({...result, ...{[item[key]]: item}}), {});

export const minutesToHours = minutes => {
    const hr = Math.floor(minutes / 60);
    const result = {minutes: `${minutes} mins`};

    if (hr > 0) {
        const mins = minutes - hr * 60;
        result.hours = `${hr} hr`;
        delete result.minutes;
        if (mins > 0) {
            result.minutes = `${mins} mins`;
        }
    }

    return ['hours', 'minutes']
        .map(unit => result[unit])
        .join(' ')
        .trim();
};

export const jsonToQueryString = params =>
    Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join('&');

export const validateUrl = string => {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === 'https:';
};

export const mapEasing = t => t * (2 - t);
